export const CBR_DAILY_FETCHED = 'currency_rates.CBR_DAILY_FETCHED';
export const USD_EUR_RATE_FETCHED = 'currency_rates.USD_EUR_RATE_FETCHED';
